/**
 * EU member-state country codes supported by Fiscalis / electronic VAT refund claim XML.
 * Greece appears as both GR (ISO) and EL (Fiscalis).
 */
export const EU_VAT_REFUND_COUNTRY_CODES = new Set([
  "AT",
  "BE",
  "BG",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "EL",
  "ES",
  "FI",
  "FR",
  "GR",
  "HR",
  "HU",
  "IE",
  "IT",
  "LT",
  "LU",
  "LV",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SE",
  "SI",
  "SK",
]);

export const CLAIM_XML_VALIDATION_UNAVAILABLE_MESSAGE =
  "Claim XML validation is not yet available for this refund country.";

export const CLAIM_XML_VALIDATION_ORIGIN_UNAVAILABLE_MESSAGE =
  "Claim XML validation is only available for customers established in the Netherlands.";

export const CLAIM_XML_DOWNLOAD_UNAVAILABLE_MESSAGE =
  "Claim XML download is not yet available for this refund country.";

export const NL_ENTITY_COUNTRY_ID = 1;

/**
 * Entity origin country IDs that have a claim XML download endpoint.
 * NL (1), BE (2), DE (5), PL (17), RO (18), CZ (21).
 */
export const CLAIM_XML_DOWNLOAD_URL_BY_ENTITY_COUNTRY_ID = {
  [NL_ENTITY_COUNTRY_ID]: "/api/v1/claims/generateClaimZIP_NL/",
  2: "/api/v1/claims/generateClaimZIP_BE/",
  5: "/api/v1/claims/generateClaimZIP_DE/",
  17: "/api/v1/claims/generateClaimZIP_PL/",
  18: "/api/v1/claims/generateClaimZIP_RO/",
  21: "/api/v1/claims/generateClaimZIP_CZ/",
};

export const isNlEntityCountry = (countryId) => Number(countryId) === NL_ENTITY_COUNTRY_ID;

export const hasClaimXmlDownloadForEntity = (countryId) =>
  Object.prototype.hasOwnProperty.call(CLAIM_XML_DOWNLOAD_URL_BY_ENTITY_COUNTRY_ID, Number(countryId));

export const getClaimXmlDownloadUrl = (countryId, claimId) => {
  const prefix = CLAIM_XML_DOWNLOAD_URL_BY_ENTITY_COUNTRY_ID[Number(countryId)];
  if (!prefix || claimId == null) {
    return null;
  }

  return `${prefix}${claimId}`;
};

export const isEuVatRefundCountry = (countryCode) => {
  if (!countryCode || typeof countryCode !== "string") {
    return false;
  }

  return EU_VAT_REFUND_COUNTRY_CODES.has(countryCode.trim().toUpperCase());
};
